var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cat-wrapper"},[_c('div',{staticClass:"cat"},[_c('h5',{staticClass:"cat-title"},[_c('img',{attrs:{"src":_vm.textimage,"alt":"alt"}})]),_c('p',{staticClass:"cat-catch"},[_vm._v(" "+_vm._s(_vm.catchcopy)+" ")]),_c('p',{staticClass:"cat-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }